import { render, staticRenderFns } from "./Lost.vue?vue&type=template&id=0c2262ee&scoped=true"
import script from "./Lost.vue?vue&type=script&lang=js"
export * from "./Lost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2262ee",
  null
  
)

export default component.exports